"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CademyFeatures = void 0;
const Features_1 = require("../Domain/Features");
exports.CademyFeatures = Features_1.Features.create({
    general: {
        name: 'General',
        description: '',
        actions: {
            customCertificates: {
                name: 'Custom Certificates',
                description: 'Customise the design, layout, and add personalised messages to certificate templates',
            },
            scorm: {
                name: 'SCORM',
                description: 'Upload SCORM compliant course content',
            },
            privateDates: {
                name: 'Private Course Dates',
                description: 'Create private course dates that are only accessible to a restricted group of attendees and not visible to public users on course pages or during checkout',
            },
            noteAttachments: {
                name: 'Note Attachments',
                description: 'Attach files to notes',
            },
            importCourses: {
                name: 'Import Courses',
                description: 'Import courses from a variety of sources',
            },
        },
    },
    marketplace: {
        name: 'Marketplace',
        description: `Host your courses on the UK's largest course marketplace`,
        actions: {
            hideProfile: {
                name: 'Hide Profile',
                description: 'Hide your profile on the Marketplace',
            },
            hideCourses: {
                name: 'Hide Courses',
                description: 'Hide your courses on the Marketplace',
            },
        },
    },
    branding: {
        name: 'Branding',
        description: '',
        actions: {
            addYourBranding: {
                name: 'Add Your Branding',
                description: 'Upload your own logo to use in emails and on the minisite',
            },
            whitelabelling: {
                name: 'Remove Cademy Branding',
                description: 'Remove all Cademy branding from embeds and minisite',
            },
            customBrandColour: {
                name: 'Custom Brand Colour',
                description: 'Customise your embeds and minisite with your brand colour',
            },
            customEmailDomain: {
                name: 'Custom Email Domain',
                description: 'Send emails from your own domain',
            },
        },
    },
    analytics: {
        name: 'Analytics',
        description: '',
        actions: {
            monthlyAnalyticsEmails: {
                name: 'Monthly Analytics Emails',
                description: 'Get a monthly digest of key metrics',
            },
        },
    },
    payments: {
        name: 'Payments',
        description: '',
        actions: {
            invoiceCheckouts: {
                name: 'Invoice Checkouts',
                description: 'Allow customers to pay by invoice on checkout',
            },
            manualPayments: {
                name: 'Manual Payments',
                description: 'Enable manual payment option on checkouts, for example bank transfer, cash, external funding, etc.',
            },
        },
    },
    privacyAndSecurity: {
        name: 'Privacy & Security',
        description: '',
        actions: {
            sso: {
                name: 'SSO',
                description: 'SAML Single Sign On',
            },
            restrictMinisite: {
                name: 'Restrict Minisite',
                description: 'Restrict minisite to users with specific email domains',
            },
            privateCourses: {
                name: 'Private Courses',
                description: 'Make your courses private',
            },
        },
    },
    apps: {
        name: 'Applications',
        description: '',
        actions: {
            zapier: {
                name: 'Zapier',
                description: 'Integrate Cademy with MailChimp, Xero, GSuite & 5,000 other apps.',
            },
        },
    },
    ai: {
        name: 'Cademy AI',
        description: '',
        actions: {
            courseGeneration: {
                name: 'Course & Lesson Generation',
                description: 'Generate course & lesson content using CademyAI',
            },
        },
    },
});
